import Box from "@mui/material/Box";
import NotFoundIcon from "../components/NotFoundIcon";

function NotFound() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "70vh",
        justifyContent:"center"
      }}
    >
      <NotFoundIcon sx={{ width: 83 * 4, height: 32 * 4 }} />
    </Box>
  );
}

export default NotFound;
